import { render, staticRenderFns } from "./BlockChainComponent.vue?vue&type=template&id=69a3b574&scoped=true"
import script from "./BlockChainComponent.vue?vue&type=script&lang=js"
export * from "./BlockChainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a3b574",
  null
  
)

export default component.exports